/**
 * 全局登录弹窗状态 — 任意页面 401 / 需登录时可打开，
 * 弹窗实例挂在 AppChrome（不随 Tab 页销毁）。
 */
import { defineStore } from 'pinia';

export const useLoginUiStore = defineStore('loginUi', {
  state: () => ({
    /** 递增以强制打开（即使已 visible 也会再触发） */
    openSeq: 0,
    /** 递增以强制关闭登录底栏（与会话确认弹框互斥） */
    closeSeq: 0,
    authCode: undefined as string | undefined,
    /** 连续 401 熔断后的会话确认弹框 */
    sessionPromptVisible: false,
  }),
  actions: {
    open(authCode?: string) {
      // 会话确认弹框展示中勿再叠登录底栏
      if (this.sessionPromptVisible) return;
      if (authCode) this.authCode = authCode;
      this.openSeq += 1;
    },
    closeLoginSheet() {
      this.closeSeq += 1;
    },
    openSessionPrompt() {
      this.sessionPromptVisible = true;
    },
    closeSessionPrompt() {
      this.sessionPromptVisible = false;
    },
    /** 保持：关弹框，请求侧已阻断 */
    confirmSessionStay() {
      this.sessionPromptVisible = false;
    },
    /** 重新登录：静默清登录态并弹登录框（不走 disconnect 刷新页） */
    confirmSessionRelogin() {
      this.sessionPromptVisible = false;
      void import('@/common/services/request')
        .then(({ beginSessionRelogin }) => beginSessionRelogin())
        .catch(() => undefined);
    },
  },
});
